module.exports = __webpack_public_path__ + "static/media/TW-inside-cover-tablet-738x57@2x.d1a9402c.jpg";